import { Button } from "@mui/material";
import get from "lodash.get";
import styled from "styled-components";

export const CancelButtonStyled = styled(Button)`
  width: 164px;
  height: 48px;
  border-radius: 16px !important;
  overflow: hidden;
  text-transform: capitalize !important;
  position: relative;
  background-color: #f5f5f5 !important;
  color: #232323 !important;
  box-shadow: none !important;
  font-weight: 600 !important;
  border: 1px solid #edf1ff !important;
  font-size: 14px;
  line-height: 17px;

  .buttonLoader {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    .backgroundOpacity {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      background-color: #fff;
      opacity: 0.4;
      z-index: 1;
    }
    .MuiCircularProgress-root.MuiCircularProgress-indeterminate {
      margin: 0 auto;
      color: #fff;
      width: 35px !important;
      height: 35px !important;
    }
  }
`;
